<template>
  <div>
    <nav-bar class="d-none d-sm-block " ref="form"/>
    <div class="primary-bg d-block d-sm-none">
      <router-link to="catalog">
        <v-btn
            elevation="0"
            color="secondary"
            class="rounded-lg m-2"
            @click="overlay = !overlay"
        >
          <i class="fas fa-angle-left"></i>
          <span class="white--text pr-5 ">بازگشت</span>
        </v-btn>
      </router-link>
    </div>
    <div class="container" v-if="isPageLoaded">
      <div class="row sec-garay-bg">
        <div class="col-12 bg-Products white--text">{{ CatalogueDetail.title }}</div>
        <iframe :src="'https://aslanianmachine.com/viewer/viewer.html?magazineMode=true&file=' + pdfUrl" class="w-100"
                allowtransparency="true" style="height:100vh"></iframe>
        <!--          <div class="col-12" v-html="CatalogueDetail.description"></div>-->
      </div>
    </div>
    <footer-menu/>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>

</template>

<script>
import NavBar from "@/components/navBar";
import FooterMenu from "@/components/footer";

export default {
  name: "CatalogDetail",
  components: {FooterMenu, NavBar},
  data: () => ({
    showLoaderDialog: false,
    isPageLoaded: false,
    CatalogueDetail: {},
    pdfUrl: null
  }),
  mounted() {

    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/CatalogueDetail?ID=" + this.$route.query.CatalogueDetailId, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.CatalogueDetail = json
            this.pdfUrl = this.$replaceHttps(json.imageUrl);
            this.isPageLoaded = true
            this.showLoaderDialog = false;
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>